
























































































































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop, Watch } from  'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { State } from 'vuex-class';
import { RootStoreState } from '../../../store/store';
import { InfoState } from '../../../core/core.store';
import ProductGroupSelectDialog from './productgroup-selection-dialog.vue';
import { currentUserKey } from '@/shared/msw-constants';
import CasApplicationSelectDialog from './cas-application-selection-dialog.vue';
import DataCenterSelection from './data-center-selection.vue';
import _ from 'lodash';
const cssPrefix = 'catalogUnit';
@Component({
  components:{
    ...UUIFComponents,
    SwTextfield,
    ProductGroupSelectDialog,
    CasApplicationSelectDialog,
    DataCenterSelection,
  },
})
export default class CatalogUnit extends SwExtendedVue {
  cssPrefix = cssPrefix;
  seviceInformation: any = {};

  picked: string = '';

  isGetTenant: boolean = false;
  showProductGroupSelectDialog: boolean = false;
  showCasApplicationSelectDialog: boolean = false;
  showDCModal: boolean = false;
  dcList: any = [
    {
      id: 'select',
      label: '--Select--',
      value: 'select',
    },
  ];
  selectedDc: any = 'select';

  requestData: any = {};

  @Prop()
  serviceInfo: any;

  @State((state: RootStoreState) => state.CatalogStoreModule.isFromHES)
  readonly isFromHES: boolean;

  @State((state: RootStoreState) => state.CatalogStoreModule.isReadOnlyAccess)
  readonly isReadOnlyAccess: boolean;

  @State((state: RootStoreState) => state.CatalogStoreModule.serialNumber)
  readonly serialNumber: string;

  @State((state: RootStoreState) => state.CatalogStoreModule.serviceTypes)
  readonly serviceTypes: any;

  @State((state: RootStoreState) => state.CatalogStoreModule.rootServiceId)
  readonly rootServiceId: any;

  @State((state: RootStoreState) => state.CatalogStoreModule.mode)
  readonly mode: string;

  @State((state: RootStoreState) => state.CatalogStoreModule.isguestbuynow)
  readonly isguestbuynow: string;

  @State((state: RootStoreState) => state.CatalogStoreModule.isguestaddedtocart)
  readonly isguestaddedtocart: boolean;

  @Watch('serviceInfo', { immediate: true })
  private onServiceInfochanges() {
    this.seviceInformation = { ...this.serviceInfo };
    this.picked = this.getServiceInfo.buyableProjectionsSelectedValue ?
      this.getServiceInfo.buyableProjectionsSelectedValue : '';
  }

  get getServiceInfo() {
    return this.seviceInformation;
  }
  created() {
    this.seviceInformation = { ...this.serviceInfo };
  }
  mounted() {
    this.picked = this.getServiceInfo.buyableProjectionsSelectedValue ?
      this.getServiceInfo.buyableProjectionsSelectedValue : '';
  }

  onEnterQuantity() {
    this.seviceInformation.quantity =  (this.seviceInformation.quantity &&
      this.seviceInformation.quantity.length > 1) ?
      this.seviceInformation.quantity.toString()
        .split('', 1)[0] :
      this.seviceInformation.quantity;
    const bisdynamiccount = false;
    const nodecount = '1';
    const childServiceId =  this.getServiceInfo.serviceId;
    if (this.serialNumber !== '' && this.serialNumber !== undefined) {
      const requestData = {
        nodecount,
        rootServiceID: this.rootServiceId,
        serialNumber: this.serialNumber,
        serviceId: childServiceId,
        quantity: this.seviceInformation.quantity ? this.seviceInformation.quantity : '1',
        isdynamicnodecount: bisdynamiccount,
      };
      this.$store.dispatch('CatalogStoreModule/getProjections', requestData)
      .then((response: any) => {
        if (response.operationStatus === 'OK') {
          const buyableProjections = response.content.hasOwnProperty('buyableProjections') ? response.content.buyableProjections : [];
          if (buyableProjections && buyableProjections.length > 0) {
            const tempServiceTypes: any[] = _.cloneDeep(this.$store.getters['CatalogStoreModule/getServiceTypes']);
            const selectedRootService: any = tempServiceTypes.filter((ele: any) => { return ele.serviceId === this.rootServiceId; })[0];
            const customizedServiceList: any[]  = selectedRootService.list ? [...selectedRootService.list] : [];
            customizedServiceList.map((service: any) => {
              if (service.serviceId === childServiceId) {
                service.buyableProjections = buyableProjections;
                service.buyableProjectionsRadio = (buyableProjections[0].optiontype === undefined ? false : true);
                service.buyableProjectionsSelectedValue = buyableProjections[0].optiontype;
              }
            });
            tempServiceTypes.map((tempElement: any) => {
              if (tempElement.serviceId === this.rootServiceId) {
                tempElement['list'] = [...customizedServiceList];
              }
            });
            this.$store.commit('CatalogStoreModule/updateServiceTypes', {
              rootServiceId: this.rootServiceId ,
              property: 'ALL',
              with: [...tempServiceTypes],
            });
          }
          this.$store.commit('stopLoading');
        } else {
          this.$store.commit('stopLoading');
          const message: InfoState = {
            infoType: 'high',
            infoMsg: response.msgDesc ? response.msgDesc :  this.$t('systemMessages.oprUnSuccss')
            .toString(),
          };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errorResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  this.$t('systemMessages.oprUnSuccss')
          .toString(),
        };
        this.$store.commit('displayMessage', message);
      });
    }
  }
  addToCartWrapper(service: any) {
    this.requestData = {
      ssipn: service.ssipn,
      quantity: service.quantity,
      users: service.users,
    };
    this.$store.commit('mutate' , {  property:'isFromHES', with : (service.isHesSku || false) });
    this.isGetTenant = service.isGetTenant || false;
    if (service.bisdynamiccount) {
      if (parseInt(service.nodecount, 10) < parseInt(service.minnodecount, 10) ||
        parseInt(service.nodecount, 10) > parseInt(service.maxnodecount, 10)) {
        const message: InfoState = { infoType: 'high', infoMsg: `User Count must be in range  ${service.minnodecount}-${service.maxnodecount}` };
        this.$store.commit('displayMessage', message);
        return;
      }
      this.requestData.nodecount = service.nodecount;
    }
    if (service.autoRenewal) {
      if (service.autoRenewalValue) {
        this.requestData.autorenew = 'YES';
      } else {
        this.requestData.autorenew = 'NO';
      }
    } else {
      this.requestData.autorenew = 'N/A';
    }
    if (this.serialNumber !== '' && this.serialNumber !== undefined) {
      this.requestData.SerialNumber = this.serialNumber;
      this.requestData.activate = 'YES';
    } else {
      this.requestData.SerialNumber = this.$store.getters.getUserId;
      this.requestData.activate = 'NO';
      if (service.serviceId.indexOf('prodSKUElement') > -1) {
        this.requestData.serviceId = '';
      } else {
        this.requestData.serviceId = service.serviceId;
      }
    }
    if (service.buyableProjectionsSelectedValue === undefined) {
      this.requestData.actionType = '';
    } else {
      this.requestData.actionType = service.buyableProjectionsSelectedValue;
    }
    if (this.isFromHES) {
      if (parseInt(service.users, 10) < parseInt(service.minnodecount, 10) ||
        parseInt(service.users, 10) > parseInt(service.maxnodecount, 10)) {
        const message: InfoState = { infoType: 'high', infoMsg: `${this.$t('catalog.usrCntMsg')
        .toString()}  ${service.minnodecount}-${service.maxnodecount}` };
        this.$store.commit('displayMessage', message);
        return;
      }
      this.requestData.nodecount = this.requestData.users;
      if (!this.isLoggedIn()) {
        sessionStorage.setItem('productAddedBeforeLogin', JSON.stringify(this.requestData));
        this.$router.push({ path: '/login',  query: { ENFORCELOGIN: 'YES' } });
      } else if (this.serialNumber === '' && this.isGetTenant) {
        this.showProductGroupSelectDialog = true;
      } else {
        this.addToCart(this.requestData);
      }
    } else {
      this.addToCart(this.requestData);
    }
  }
  addToCartFromDcModal(val: any) {
    this.requestData.dataCenterLocationID = val;
    this.addToCart(this.requestData);
  }
  addToCart(requestData: any) {
    this.$store.dispatch('CatalogStoreModule/addToCart', requestData)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          this.showDCModal = false;
          if (response.msgCode === 'MSWAPP:NEEDCASBAPPLICATION') {
            this.showCasApplicationSelectDialog = true;
          } else {
            this.$store.dispatch('CatalogStoreModule/changeCartCount', response.content.cartCount || 0);
            if (this.isguestbuynow === 'true') {
              this.$store.commit('mutate' , {  property:'isguestaddedtocart', with : true });
            }
            const message: InfoState = {
              infoType: 'success',
              infoMsg: response.msgDesc ? response.msgDesc :  this.$t('systemMessages.oprSuccess')
              .toString(),
            };
            this.$store.commit('displayMessage', message);
            if (this.isFromHES) {
              this.$router.push('cart');
            }
          }
        } else {
          if (response.msgCode === 'MSWAPP:DCREQUIRED') {
            console.warn('DC is needed');
            this.dcList = [
              {
                id: 'select',
                label: '--Select--',
                value: 'select',
              },
            ];
            this.selectedDc = 'select';
            this.showDCModal = true;
            response?.dataCenter.map((item: any) => {
              const obj: any = {
                id: item.dataCenterId,
                label: item.dataCenterDesc,
                value: item.dataCenterId,
              };
              this.dcList.push(obj);
              if (item.isDefaultDc) this.selectedDc = item.dataCenterId;
            });
          } else {
            this.$store.commit('stopLoading');
            const message: InfoState = {
              infoType: 'high',
              infoMsg: response.msgDesc ? response.msgDesc :  this.$t('systemMessages.oprUnSuccss')
              .toString(),
            };
            this.$store.commit('displayMessage', message);
          }
        }
      })
      .catch((errResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = {
          infoType: 'high',
          infoMsg: errResponse.msgDesc ? errResponse.msgDesc :  this.$t('systemMessages.oprUnSuccss')
          .toString(),
        };
        this.$store.commit('displayMessage', message);
      });
  }
  closeProductGroupDialog(result: any) {
    if (result && result !== null && result !== undefined) {
      this.requestData.tenantID = result.productGroupId || result.partyGroupId;
      this.checkHesPresence(this.requestData);
    } else {
      this.requestData = {};
    }
    this.showProductGroupSelectDialog = false;
  }
  checkHesPresence(requestData: any) {
    this.$store.dispatch('CatalogStoreModule/checkHesPresence', requestData.tenantID)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.content &&
            response.content.hasOwnProperty('isValid') &&
            response.content.isValid) {
          this.addToCart(requestData);
        } else {
          this.$store.commit('stopLoading');
          const message: InfoState = {
            infoType: 'high',
            infoMsg: response.msgDesc ? response.msgDesc :  this.$t('systemMessages.oprUnSuccss')
            .toString(),
          };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = {
          infoType: 'high',
          infoMsg: errResponse.msgDesc ? errResponse.msgDesc :  this.$t('systemMessages.oprUnSuccss')
          .toString(),
        };
        this.$store.commit('displayMessage', message);
      });
  }
  isLoggedIn(): boolean {
    if (this.$store.getters.getUserId &&
        this.$store.getters.getUserId.toUpperCase() === 'GUESTBUYNOW') {
      return true;
    }
    return (localStorage.getItem(currentUserKey) &&
            this.$store.getters.getUserInfo &&
            this.$store.getters.getUserInfo.token &&
            this.$store.getters.getUserInfo.sessionId) ?
            true :
            false;
  }
  beforeDestroy() {
    this.requestData = {};
    this.seviceInformation = {};
    this.picked = '';
  }
  closeCasApplicationSelectDialog(result: any) {
    if (result && result !== null && result !== undefined) {
      this.requestData.casbAppid = result;
      this.addToCartWithCAS(this.requestData);
    } else {
      this.requestData = {};
    }
    this.showCasApplicationSelectDialog = false;
  }
  addToCartWithCAS(requestData : any) {
    this.$store.dispatch('CatalogStoreModule/addToCart', requestData)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          this.$store.dispatch('CatalogStoreModule/changeCartCount', response.content.cartCount || 0);
          const message: InfoState = {
            infoType: 'success',
            infoMsg: response.msgDesc ? response.msgDesc :  this.$t('systemMessages.oprSuccess')
            .toString(),
          };
          this.$store.commit('displayMessage', message);
        } else {
          const message: InfoState = {
            infoType: 'high',
            infoMsg: response.msgDesc ? response.msgDesc :  this.$t('systemMessages.oprUnSuccss')
            .toString(),
          };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = {
          infoType: 'high',
          infoMsg: errResponse.msgDesc ? errResponse.msgDesc :  this.$t('systemMessages.oprUnSuccss')
          .toString(),
        };
        this.$store.commit('displayMessage', message);
      });
  }
}
